/* template */
<template><div class="mpx-root-view"><div class="flights-container"><QueryCard ref="QueryCard"/><Diamonds :diamondsConf="(diamondsConf)" @pageGoTo="pageGoTo" class="diamonds" v-if="(diamondsConf.length)"/><FlightsCouponBanner class="coupon-area" v-if="(gotCoupons)"/><SpecialTicket :mixinShowProp="(mixinShowProp)" @specialTicketTap="onSpecialTicketTap"/><Service :notices="(notices)"/><Slogan sloganIcon="https://ut-static.udache.com/webx/sfc/Omh3erNxbVue_HKBMUB5l.png"/><Privacy :list="(privacyList)" @privacyVerify="onPrivacyVerify" scene="didijipiao" caller="flights_home_to_tc" v-if="(privacyVisible)"/></div><FlightsFallingPopup :fallingConf="(flightsFallingConf)" v-if="(gotCoupons)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3d75fc2c"}'>
  .flights-container
    box-sizing border-box
    height auto
    padding 0 10px
    .diamonds
      margin 8px auto
    .coupon-area
      margin-bottom 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3d75fc2c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex3d75fc2c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex3d75fc2c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3d75fc2c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index3d75fc2c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Diamonds':getComponent(require("../diamonds/index.mpx?isComponent&outputPath=components%2Findex2d8bbd20%2Findex")),'Slogan':getComponent(require("../../../../components/slogan/index.mpx?isComponent&outputPath=components%2Findexee4c3584%2Findex")),'Privacy':getComponent(require("../../../train-detail/components/privacy/index.mpx?isComponent&outputPath=components%2Findex6f368ef8%2Findex")),'SpecialTicket':getComponent(require("./special-ticket.mpx?isComponent&outputPath=components%2Fspecial-ticket106bbc36%2Findex")),'QueryCard':getComponent(require("./query-card-flights.mpx?isComponent&outputPath=components%2Fquery-card-flights313f25c1%2Findex")),'Service':getComponent(require("../../../../components/home-service/index.mpx?isComponent&outputPath=components%2Findex49c10132%2Findex")),'FlightsCouponBanner':getComponent(require("../../../../components/flights-coupon/coupon-banner/index.mpx?isComponent&outputPath=components%2Findex1a0f7174%2Findex")),'FlightsFallingPopup':getComponent(require("../../../../components/flights-coupon/falling-popup/index.mpx?isComponent&outputPath=components%2Findexba71be32%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
